import * as formsActionTypes from '../constants/formsAction-Types';

export const postForm = (values) => ({
  type: formsActionTypes.POST_FORM,
  payload: {
    data: values,
  },
});

export const deleteLastPostForm = () => ({
  type: formsActionTypes.DELETE_LAST_POST_FORM,
});

export const cleanForm = () => ({
  type: formsActionTypes.CLEAN_FORM,
});
